export const userPaths = {
  profile: {
    absolute: '/:clientId/profile',
    relative: '/:clientId/profile',
  },

  manageUsers: {
    absolute: '/:clientId/users',
    relative: '/:clientId/users',
  },
} as const;
